import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, unref as _unref, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "user-form-component" }
const _hoisted_2 = { class: "form-field-floating reactive active my-5" }
const _hoisted_3 = {
  key: 0,
  class: "text-red"
}
const _hoisted_4 = { class: "form-field-floating lg reactive active my-5" }
const _hoisted_5 = {
  key: 1,
  class: "text-red"
}
const _hoisted_6 = { class: "form-field-split active my-5" }
const _hoisted_7 = { class: "form-field-floating lg reactive half" }
const _hoisted_8 = {
  key: 2,
  class: "text-red"
}
const _hoisted_9 = {
  key: 3,
  class: "text-red"
}
const _hoisted_10 = { class: "form-field-floating lg reactive active my-5" }
const _hoisted_11 = { class: "form-field-split active my-5" }
const _hoisted_12 = { class: "form-field-floating reactive half" }
const _hoisted_13 = { class: "form-field-floating reactive half" }
const _hoisted_14 = {
  key: 4,
  class: "text-red"
}
const _hoisted_15 = {
  key: 5,
  class: "text-red"
}
const _hoisted_16 = { class: "form-field-split active my-5" }
const _hoisted_17 = { class: "form-field-floating reactive half" }
const _hoisted_18 = { class: "form-field-floating reactive half" }
const _hoisted_19 = {
  key: 6,
  class: "text-red"
}
const _hoisted_20 = {
  key: 7,
  class: "text-red"
}
const _hoisted_21 = { class: "form-field-floating active my-4" }
const _hoisted_22 = ["value"]
const _hoisted_23 = {
  key: 0,
  class: "text-red"
}
const _hoisted_24 = { class: "form-field-floating reactive active my-5" }
const _hoisted_25 = {
  key: 0,
  class: "text-red"
}
const _hoisted_26 = { class: "form-field-split active my-5" }
const _hoisted_27 = { class: "form-field-floating reactive half" }
const _hoisted_28 = { class: "form-field-floating reactive half" }
const _hoisted_29 = {
  key: 1,
  class: "text-red"
}
const _hoisted_30 = {
  key: 2,
  class: "text-red"
}
const _hoisted_31 = { class: "custom-upload-size margin-auto flex mb-8" }

import { computed } from "vue";
    import { reactive, watch } from 'vue';
    import moment from 'moment';
    import CustomUploadInput from '@/components/CustomUploadInput.vue';
    import { AMOUNT_FORMAT_CONFIG, PERCENTAGE_FORMAT_CONFIG } from '@/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UserFormComponent',
  props: {
    modelValue: {},
    collectivites: {},
    collectiviteId: {},
    showCollectiviteField: { type: Boolean },
    fullWidth: { type: Boolean },
    errors: {}
  },
  emits: ["update:modelValue", "validate"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

    // @ts-expect-error raison: lib externe mal typée
    const props = __props;

    const emit = __emit;

    const localFormData = reactive({ ...props.modelValue });

    // Synchroniser les props avec les données locales
    watch(() => props.modelValue, (newValue) => {
        Object.assign(localFormData, newValue);
    }, { deep: true });

    // Émettre les changements vers le parent
    watch(localFormData, (newValue) => {
        emit('update:modelValue', { ...newValue });
        emit('validate');
    }, { deep: true });

    // Si collectiviteId est fourni en prop, l'utiliser automatiquement
    watch(() => props.collectiviteId, (newValue) => {
        if (newValue && !props.showCollectiviteField) {
            localFormData.collectivite_id = newValue;
        }
    }, { immediate: true });

    // Calculer l'âge automatiquement
    watch(() => localFormData.date_naissance, (newDate) => {
        if (newDate) {
            const birthDate = moment(newDate);
            if (birthDate.isValid()) {
                localFormData.age = moment().diff(birthDate, 'years');
            }
        }
    });

    // Calculer l'ancienneté automatiquement
    watch(() => localFormData.date_engagement, (newDate) => {
        if (newDate) {
            const engagementDate = moment(newDate);
            if (engagementDate.isValid()) {
                localFormData.anciennete = moment().diff(engagementDate, 'years');
            }
        }
    });

    function doCalculateQuotiteCessible() {
        const salaire = parseFloat(localFormData.salaire);
        const quotitePourcent = parseFloat(localFormData.quotite_cessible_pourcent);

        if (!isNaN(salaire) && !isNaN(quotitePourcent) && salaire > 0 && quotitePourcent > 0) {
            localFormData.quotite_cessible_montant = String(salaire * (quotitePourcent / 100));
        } else {
            localFormData.quotite_cessible_montant = '';
        }
    }

    function onFileUploaded(uploadedFile: { file: any, file_name: string, file_preview: string }) {
        localFormData.photo_preview = uploadedFile.file_preview;
        localFormData.photo = { file: uploadedFile.file, name: uploadedFile.file_name };
    }

    // Exposer les données pour validation externe
    __expose({
        formData: localFormData
    });

return (_ctx: any,_cache: any) => {
  const _component_custom_phone_input = _resolveComponent("custom-phone-input")!
  const _component_money3 = _resolveComponent("money3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.fullWidth ? '' : 's10_mobile container-full-2')
    }, [
      _cache[24] || (_cache[24] = _createElementVNode("h2", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
        _createElementVNode("img", {
          src: "/icons/icon-info-perso.svg",
          class: "size-l",
          alt: ""
        }),
        _createTextVNode(" Informations personnelles ")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-input",
          name: "nom",
          id: "user_nom",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localFormData.nom) = $event)),
          placeholder: ""
        }, null, 512), [
          [_vModelText, localFormData.nom]
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("label", { for: "user_nom" }, [
          _createTextVNode("Nom "),
          _createElementVNode("b", { class: "color-danger" }, "*")
        ], -1))
      ]),
      (_ctx.errors?.nom)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.errors.nom), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-input",
          name: "prenom",
          id: "user_prenom",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localFormData.prenom) = $event)),
          placeholder: ""
        }, null, 512), [
          [_vModelText, localFormData.prenom]
        ]),
        _cache[14] || (_cache[14] = _createElementVNode("label", { for: "user_prenom" }, [
          _createTextVNode("Prénom "),
          _createElementVNode("b", { class: "color-danger" }, "*")
        ], -1))
      ]),
      (_ctx.errors?.prenom)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.errors.prenom), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_custom_phone_input, {
          modelValue: localFormData.telephone,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localFormData.telephone) = $event)),
          id: "user_telephone",
          classesNames: "half"
        }, null, 8, ["modelValue"]),
        _cache[16] || (_cache[16] = _createElementVNode("hr", { class: "hr" }, null, -1)),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "email",
            class: "form-input",
            name: "email",
            id: "user_email",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((localFormData.email) = $event)),
            placeholder: ""
          }, null, 512), [
            [_vModelText, localFormData.email]
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("label", { for: "user_email" }, [
            _createTextVNode("Adresse Email "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ])
      ]),
      (_ctx.errors?.telephone)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.errors.telephone), 1))
        : _createCommentVNode("", true),
      (_ctx.errors?.email)
        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.errors.email), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-input",
          name: "fonction",
          id: "user_fonction",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((localFormData.fonction) = $event)),
          placeholder: ""
        }, null, 512), [
          [_vModelText, localFormData.fonction]
        ]),
        _cache[17] || (_cache[17] = _createElementVNode("label", { for: "user_fonction" }, "Fonction", -1))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            type: "date",
            class: "form-input",
            name: "date_naissance",
            id: "user_date_naissance",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((localFormData.date_naissance) = $event)),
            placeholder: ""
          }, null, 512), [
            [_vModelText, localFormData.date_naissance]
          ]),
          _cache[18] || (_cache[18] = _createElementVNode("label", { for: "user_date_naissance" }, [
            _createTextVNode("Date de naissance "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        _cache[20] || (_cache[20] = _createElementVNode("hr", { class: "hr" }, null, -1)),
        _createElementVNode("div", _hoisted_13, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            name: "age",
            id: "user_age",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((localFormData.age) = $event)),
            placeholder: "",
            readonly: ""
          }, null, 512), [
            [_vModelText, localFormData.age]
          ]),
          _cache[19] || (_cache[19] = _createElementVNode("label", { for: "user_age" }, [
            _createTextVNode("Age "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ])
      ]),
      (_ctx.errors?.date_naissance)
        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.errors.date_naissance), 1))
        : _createCommentVNode("", true),
      (_ctx.errors?.age)
        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.errors.age), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _withDirectives(_createElementVNode("input", {
            type: "date",
            class: "form-input",
            name: "date_engagement",
            id: "user_date_engagement",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((localFormData.date_engagement) = $event)),
            placeholder: ""
          }, null, 512), [
            [_vModelText, localFormData.date_engagement]
          ]),
          _cache[21] || (_cache[21] = _createElementVNode("label", { for: "user_date_engagement" }, [
            _createTextVNode("Date d'engagement "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        _cache[23] || (_cache[23] = _createElementVNode("hr", { class: "hr" }, null, -1)),
        _createElementVNode("div", _hoisted_18, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            name: "anciennete",
            id: "user_anciennete",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((localFormData.anciennete) = $event)),
            placeholder: "",
            readonly: ""
          }, null, 512), [
            [_vModelText, localFormData.anciennete]
          ]),
          _cache[22] || (_cache[22] = _createElementVNode("label", { for: "user_anciennete" }, [
            _createTextVNode("Ancienneté "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ])
      ]),
      (_ctx.errors?.date_engagement)
        ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.errors.date_engagement), 1))
        : _createCommentVNode("", true),
      (_ctx.errors?.anciennete)
        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.errors.anciennete), 1))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.showCollectiviteField)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.fullWidth ? '' : 's10_mobile container-full-2')
        }, [
          _cache[27] || (_cache[27] = _createElementVNode("h2", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
            _createElementVNode("img", {
              src: "/icons/icon-info-collectivite.svg",
              class: "size-l",
              alt: ""
            }),
            _createTextVNode(" Collectivité ")
          ], -1)),
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("select", {
              class: "form-input-select",
              name: "collectivite_id",
              id: "user_collectivite_id",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((localFormData.collectivite_id) = $event))
            }, [
              _cache[25] || (_cache[25] = _createElementVNode("option", {
                value: null,
                selected: ""
              }, "Sélectionnez une collectivité", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collectivites, (collectivite, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: collectivite.id,
                  key: 'collectivite_' + index
                }, _toDisplayString(collectivite.nom), 9, _hoisted_22))
              }), 128))
            ], 512), [
              [_vModelSelect, localFormData.collectivite_id]
            ]),
            _cache[26] || (_cache[26] = _createElementVNode("label", { for: "user_collectivite_id" }, [
              _createTextVNode("Collectivité "),
              _createElementVNode("b", { class: "color-danger" }, "*")
            ], -1))
          ]),
          (_ctx.errors?.collectivite_id)
            ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.errors.collectivite_id), 1))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.fullWidth ? '' : 's10_mobile container-full-2')
    }, [
      _cache[35] || (_cache[35] = _createElementVNode("h2", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
        _createElementVNode("img", {
          src: "/icons/icon-engagement.svg",
          class: "size-l",
          alt: ""
        }),
        _createTextVNode(" Engagement ")
      ], -1)),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_money3, _mergeProps({
          class: "form-input",
          modelValue: localFormData.salaire,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((localFormData.salaire) = $event)),
          name: "salaire",
          id: "user_salaire",
          placeholder: ""
        }, _unref(AMOUNT_FORMAT_CONFIG), { onBlur: doCalculateQuotiteCessible }), null, 16, ["modelValue"]),
        _cache[28] || (_cache[28] = _createElementVNode("label", { for: "user_salaire" }, [
          _createTextVNode("Salaire brut "),
          _createElementVNode("b", { class: "color-danger" }, "*")
        ], -1)),
        _cache[29] || (_cache[29] = _createElementVNode("span", null, "F CFA", -1))
      ]),
      (_ctx.errors?.salaire)
        ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.errors.salaire), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_money3, _mergeProps({
            class: "form-input",
            modelValue: localFormData.quotite_cessible_pourcent,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((localFormData.quotite_cessible_pourcent) = $event)),
            name: "quotite_cessible_pourcent",
            id: "user_quotite_cessible_pourcent",
            placeholder: ""
          }, _unref(PERCENTAGE_FORMAT_CONFIG), { onBlur: doCalculateQuotiteCessible }), null, 16, ["modelValue"]),
          _cache[30] || (_cache[30] = _createElementVNode("label", { for: "user_quotite_cessible_pourcent" }, [
            _createTextVNode("Quotité cessible max "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1)),
          _cache[31] || (_cache[31] = _createElementVNode("span", null, "%", -1))
        ]),
        _cache[34] || (_cache[34] = _createElementVNode("hr", { class: "hr" }, null, -1)),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_money3, _mergeProps({
            class: "form-input",
            modelValue: localFormData.quotite_cessible_montant,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((localFormData.quotite_cessible_montant) = $event)),
            name: "quotite_cessible_montant",
            id: "user_quotite_cessible_montant",
            placeholder: ""
          }, _unref(AMOUNT_FORMAT_CONFIG), { readonly: "" }), null, 16, ["modelValue"]),
          _cache[32] || (_cache[32] = _createElementVNode("label", { for: "user_quotite_cessible_montant" }, [
            _createTextVNode("Valeur "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1)),
          _cache[33] || (_cache[33] = _createElementVNode("span", null, "F CFA", -1))
        ])
      ]),
      (_ctx.errors?.quotite_cessible_pourcent)
        ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.errors.quotite_cessible_pourcent), 1))
        : _createCommentVNode("", true),
      (_ctx.errors?.quotite_cessible_montant)
        ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.errors.quotite_cessible_montant), 1))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.fullWidth ? '' : 's10_mobile container-full-2')
    }, [
      _cache[36] || (_cache[36] = _createElementVNode("h2", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
        _createElementVNode("img", {
          src: "/icons/icon-photo.svg",
          class: "size-l",
          alt: ""
        }),
        _createTextVNode(" Photo ")
      ], -1)),
      _createElementVNode("div", _hoisted_31, [
        _createVNode(CustomUploadInput, {
          id: "user_photo",
          label: "Photo",
          type: "IMAGE",
          size: "small",
          preview: localFormData.photo_preview,
          onUploaded: onFileUploaded
        }, null, 8, ["preview"])
      ])
    ], 2)
  ]))
}
}

})